import React from 'react'
import Footer from '../component/Footer'

import Thyroid from '../Media/img/Thyroid.png'

const ThyroidMedia = () => {
  return (
    <>
      <div className="headings">
        <h1>Thyroid Media</h1>
      </div>


      <div style={{ width: '100%' }}>
        <img src={Thyroid} style={{ width: '100%' }} />
      </div>

      <Footer />
    </>
  )
}

export default ThyroidMedia





